import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DetailOrderRequest, OrderRequest } from 'src/app/models/order.model';
import { ProductResponse } from 'src/app/models/product.model';
import { ResponseObject } from 'src/app/models/response-object.model';
import { WarehouseResponse } from 'src/app/models/warehouse.model';
import { OrderService } from 'src/app/services/order.service';
import { ProductService } from 'src/app/services/product.service';
import { WarehouseService } from 'src/app/services/warehouse.service';
import { AuthenticationService } from '../../pages/authentication/authentication/authentication.service';

@Component({
  selector: 'app-modal-create-order',
  templateUrl: './modal-create-order.component.html',
  styleUrls: ['./modal-create-order.component.scss']
})
export class ModalCreateOrderComponent implements OnInit {
  loading = false;
  date = new Date();
  @Output() close = new EventEmitter<boolean>();
  newOrder: OrderRequest = new OrderRequest();
  inputs = {
    warehouse: {
      value: null,
      verified: false,
      required: true,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null
      }
    },
    product: {
      value: null,
      verified: false,
      required: false,
      message: 'Campo requerido',
      class: "fa-list",
      color: '',
      tooltip: '',
      data: {
        id: null
      }
    }
  };
  warehouses: WarehouseResponse[] = [];
  products: ProductResponse[] = [];
  filterWarehouses: WarehouseResponse[] = [];
  filterProducts: ProductResponse[] = [];
  timeout = null;
  quantity = 0;
  productList = [];
  allowedWarehouses: { [key: number]: boolean } = {};

  constructor(
    private warehouseService: WarehouseService,
    private productService: ProductService,
    private toastService: ToastrService,
    private orderService: OrderService,
    private authService: AuthenticationService
  ) {
    var getUserPosition = authService.getUserPosition();
    if (getUserPosition) {
      getUserPosition.forEach((u) => {
        if (u.warehouse != 0) {
          this.allowedWarehouses[u.warehouse] = true;
        }
      });
    }
  }

  ngOnInit(): void {
    this.getInitialData();
  }

  getInitialData() {
    this.getWarehouses("");
    this.getProducts("");
  }

  changeInput(input, value, verified, required, classIcon, data) {
    input.value = (value) ? value : input.value;
    input.verified = (verified) ? verified : input.verified;
    input.required = (required) ? required : input.required;
    input.class = (classIcon) ? classIcon : input.class;
    input.data = (data) ? data : input.data;
  }

  getWarehouses(clue) {
    this.warehouseService.getWarehouseByClue(clue).subscribe({
      next: (response: ResponseObject) => {
        this.warehouses = response.data;
        this.filterWarehouses = this.warehouses.filter((w)=>{
          return this.allowedWarehouses[w.id];
        });
        if (this.filterWarehouses.length == 0) {
          this.changeInput(this.inputs.warehouse, null, false, null, 'fa-xmark', null);
        } else if (this.filterWarehouses.length == 1) {
          this.changeInput(this.inputs.warehouse, this.filterWarehouses[0].name, true, null, 'fa-circle-check', this.filterWarehouses[0]);
        } else {
          if (clue == "") {
            this.changeInput(this.inputs.warehouse, clue, false, null, 'fa-asterisk', null);
          } else {
            this.changeInput(this.inputs.warehouse, clue, false, null, 'fa-list', null);
          }
        }
      },
      error: (error: HttpErrorResponse) => {
        this.changeInput(this.inputs.warehouse, null, false, null, 'fa-xmark', null);
        this.toastService.error(error.error.message);
      }
    });
  }

  getProducts(clue) {
    this.productService.getProducts(clue).subscribe({
      next: (response: ResponseObject) => {
        this.products = response.data
        this.filterProducts = this.products;
        if (this.filterProducts.length == 0) {
          this.changeInput(this.inputs.product, null, false, null, 'fa-xmark', null);
        } else if (this.filterProducts.length == 1) {
          this.changeInput(this.inputs.product, this.filterProducts[0].name, true, null, 'fa-circle-check', this.filterProducts[0]);
        } else {
          this.changeInput(this.inputs.product, clue, false, null, 'fa-list', null);
        }
      },
      error: (error: HttpErrorResponse) => {
        this.changeInput(this.inputs.warehouse, null, false, null, 'fa-xmark', null);
        this.toastService.error(error.error.message);
      }
    });
  }

  addProduct() {
    this.productList.push({ productData: this.inputs.product.data, quantity: this.quantity });
    this.inputs.product.value = "";
    this.quantity = 0;
    this.getProducts('');
  }

  deleteProductFromList(index: number) {
    this.productList.splice(index, 1);
  }

  writeWarehouse(input) {
    var inputValue = input.target.value;
    clearTimeout(this.timeout);
    this.inputs.warehouse.class = "typing";
    this.timeout = setTimeout(() => {
      this.getWarehouses(inputValue);
    }, 500);
  }

  checkWarehouse(warehouse: WarehouseResponse) {
    this.inputs.warehouse.class = "fa-circle-check";
    this.inputs.warehouse.verified = true;
    this.inputs.warehouse.data = warehouse;
    this.inputs.warehouse.value = warehouse.name;
  }

  writeProduct(input) {
    var inputValue = input.target.value;
    clearTimeout(this.timeout);
    this.inputs.product.class = "typing";
    this.timeout = setTimeout(() => {
      this.getProducts(inputValue);
    }, 500);
  }

  checkProduct(product: WarehouseResponse) {
    this.changeInput(this.inputs.product, product.code + " - " + product.name, true, null, "fa-circle-check", product);
  }

  createOrder() {
    if (this.loading) {
      return;
    }
    this.loading = true;
    this.newOrder.detail = [];
    this.productList.forEach((p) => {
      this.newOrder.detail.push(new DetailOrderRequest(p.productData.id, p.quantity));
    })
    this.newOrder.date = new Date(this.date).getTime();
    this.newOrder.warehouse = this.inputs.warehouse.data.id;
    this.orderService.addOrder(this.newOrder).subscribe({
      next: (response: ResponseObject) => {
        this.newOrder = new OrderRequest();
        this.toastService.success("Pedido creado correctamente!");
        this.loading = false;
        this.close.emit(true);
      },
      error: (error: HttpErrorResponse) => {
        this.loading = false;
        this.toastService.error(error.error.message);
      }
    });
  }
}
